// extracted by mini-css-extract-plugin
export default {"root":"jkU2ia_SNnjylfsSw5iJ","img":"KfbGAy3alKT8a4OMWcUc"};